export const GET_BASKET = "basket/GET_BASKET";
export const UPDATE_BASKET = "basket/UPDATE_BASKET";
export const DELETE_BASKET = "basket/DELETE_BASKET";
